/** @ignore */
export const VERSION_GENERATE_START_NUM = 2
